export const getDisplayPrice = (servingSize, orderType) => {
    if (!servingSize) return 0;
    if (orderType == 'takeaway' || orderType == 'phone') {
      return servingSize.takeaway_pos_price > 0
        ? servingSize.takeaway_pos_price
        : servingSize.price;
    }
    return servingSize.dine_in_price;
  };
  